export default {
	APPLICATION: {
		RESET: Symbol("APPLICATION_RESET")
	}
};
